import { ReportReason } from './report';

export enum StoryStatus {
    New = 'new',
    Declined = 'declined', // deprecated
    Approved = 'approved', // deprecated
    NotConverted = 'notConverted',
    Active = 'active',
    Deleted = 'deleted',
    ErrorConvert = 'errorConvert',
    Inactive = 'inactive',
    DeletedByGdpr = 'deletedByGdpr'
}

export enum ModerationStatus {
    Required = 'required',
    Approved = 'approved',
    Declined = 'declined',
    AutoDeclined = 'autoDeclined',
    AutoApproved = 'autoApproved',
}

export enum DeleteReason {
    Underage = `${ReportReason.Underage}`,
    Illegal = `${ReportReason.Illegal}`,
    Animals = `${ReportReason.Animals}`,
    Violence = `${ReportReason.Violence}`,
    HateSpeech = `${ReportReason.HateSpeech}`,
    Scam = `${ReportReason.Scam}`,
    Spam = `${ReportReason.Spam}`,
    Harassment = `${ReportReason.Harassment}`,
    Other = `${ReportReason.Other}`,
    NoOneInVideo = `${ReportReason.NoOneInVideo}`,
    MoreOneInVideo = `${ReportReason.MoreOneInVideo}`,
    UserRequest = 'userRequest',
    Nudity = `${ReportReason.Nudity}`,
}
